import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import Row from 'muicss/lib/react/row';
import Col from 'muicss/lib/react/col';
import MyIngredientItems from 'components/SearchPanel/MyIngredientItems';
import MenuEngineeringItems from 'components/SearchPanel/MenuEngineeringItems';
import ChangeAccountItems from 'components/SearchPanel/ChangeAccountItems';
import RecipeSearchItems from 'components/SearchPanel/RecipeSearchItems';

class SearchPanel extends Component {
  static propTypes = {
    searchItemsList: PropTypes.object,
    onSearch: PropTypes.func,
    onClear: PropTypes.func,
    onItemClick: PropTypes.func,
    itemSource: PropTypes.string,
    searchPlaceholder: PropTypes.string,
    ingredientSearch: PropTypes.bool,
    disabled: PropTypes.bool,
    onBlur: PropTypes.func,
    keyword: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      showClear: false,
      skey: '',
      updated: false,
    }

    this.onSearch = this.onSearch.bind(this);
    this.onToggleClearSearch = this.onToggleClearSearch.bind(this);
    this.onInputEvent = this.onInputEvent.bind(this);
    this.onKeyChange = this.onKeyChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onItemClick = this.onItemClick.bind(this);
    this.onAccountItemClick = this.onAccountItemClick.bind(this);
  }

  componentDidMount() {
    const { keyword } = this.props;    
    if (keyword) {
      this.refs.skey.value = keyword;
      this.setState({ showClear: true });
    }
  }

  componentDidUpdate(prevProps) {
    const { keyword } = this.props;
    if (keyword !== prevProps.keyword) {
      this.refs.skey.value = keyword || '';
    }
  }

  onSearch(kn) {
    const { onSearch, ingredientSearch, keyword } = this.props;
    const skey = this.refs.skey.value.trim();
    const updated = skey !== keyword;
    const state = ingredientSearch ? { skey, updated, } : { skey };

    this.setState(state);
    if (onSearch) {
      onSearch(kn, skey, updated);
    }
    if (kn === 'Enter' || kn === 'Search') {
      this.setState({ showClear: !!skey });
    }
  }

  onItemClick(id, title, tabName) {
    const { onItemClick } = this.props;
    onItemClick(id, title, tabName);
    this.refs.skey.value = title;
    this.setState({ skey: '', showClear: true });
  }

  onAccountItemClick(customerName, customerNum, opcoName, opcoNum) {
    const { onItemClick } = this.props;
    const uppercaseSearchKey = this.refs.skey.value.trim().toUpperCase();
    const searchedKey = customerName.toUpperCase().includes(uppercaseSearchKey) ? customerName
      : customerNum.toUpperCase().includes(uppercaseSearchKey) ? customerNum
      : opcoName.toUpperCase().includes(uppercaseSearchKey) ? opcoName
      : opcoNum.toUpperCase().includes(uppercaseSearchKey) ? opcoNum : customerName;
    this.refs.skey.value = searchedKey;
    onItemClick(customerNum, searchedKey);
    this.setState({ skey: '', showClear: true });
  }

  onInputEvent(event) {
    if (event.keyCode === 13) {
      var object = this.refs.skey;
      object.blur();
      this.onSearch('Enter');
      this.setState({ skey: '' });
      event.preventDefault();
    }
  }

  onToggleClearSearch() {
    const { showClear } = this.state;
    if(showClear) {
      this.onClear();
    } else {
      this.onSearch('Search');
    }
    this.setState({ skey: '' });
  }

  onKeyChange() {
    this.onSearch('KeyChange');
  }

  onFocus(e) {
    const searchText = this.refs.skey.value.trim();

    if (!searchText && !this.props.keyword) {
      this.setState({ showClear: false });
    } else {
      this.setState({
        showClear: true,
        skey: searchText,
      });
      this.onSearch('KeyChange');
    }
  }

  onBlur() {
    const { onBlur, keyword } = this.props;
    const { showClear } = this.state;

    const skey = this.refs.skey.value.trim();
    const hasUpdated = skey !== keyword && (skey || keyword);

    if (onBlur && hasUpdated) {
      onBlur(skey);
      if (showClear && !skey) {
        this.setState({ showClear: false });
      }
    }
  }

  onClear() {
    const { onClear } = this.props;
    this.refs.skey.value = '';
    this.setState({ skey: '' , showClear: false });
    onClear();
  }

  renderSuggestions = () => {
    const { searchItemsList, itemSource } = this.props;
    const { skey } = this.state;

    return (
      <div className={classNames('search-list', { 'shh': skey !== '' })} id='customize-scrollbar'>
        { searchItemsList.size > 0 ?
          searchItemsList.map((item, index) => {
            if (itemSource === 'MyIngredientItems') {
              return (
                <MyIngredientItems
                  key={`${item.id}-${index}`}
                  id={item.id}
                  title={`${item.name}`}
                  onItemClick={this.onItemClick}
                  tabName={item.tabName}
                  skey={skey}
                />
              );
            } else if (itemSource === 'MenuEngineeringItems') {
              return (
                <MenuEngineeringItems
                  key={`${item.get('id')}-${index}`}
                  id={item.get('id')}
                  title={`${item.get('title')}`}
                  onItemClick={this.onItemClick}
                  skey={skey}
                />
              );
            } else if (itemSource === 'ChangeAccountItems') {
              return (
                <ChangeAccountItems
                  key={`${item.get('name')}-${index}`}
                  customerNum={item.get('accountId')}
                  customerName={item.get('name')}
                  customerAddress= {item.get('address')}
                  onItemClick={this.onAccountItemClick}
                  skey={skey}
                />
              );
            }
            else if (itemSource === 'RecipeSearchItems') {

              return (
                <RecipeSearchItems
                  key={`${item.get('id')}-${index}`}
                  id={item.get('id')}
                  title={`${item.get('recipeName')}`}
                  onItemClick={this.onItemClick}
                  skey={skey}
                />
              );
            }
          }) : <div className='not-found'>No results found</div>
        }
      </div>
    )
  }

  onClick = () => {
    if (this.props.ingredientSearch) {
      return;
    } else {
      this.onToggleClearSearch();
    }
  }

  onChange = currState => {
    const prevKeyword = this.props.keyword;
    const currenctKeyword = currState.skey;
    if (currenctKeyword && currenctKeyword !== prevKeyword) {
      this.setState({
        updated: true
      })
    }
  }

  render() {
    const { searchPlaceholder, ingredientSearch, disabled } = this.props;
    const { showClear } = this.state;

    return (
      <div>
        <Row className='search-panel'>
          <Col md='10' className='search-col'>
            <div className='search-div'>
              <div className='input-div'>
                <input
                  type='search'
                  placeholder={searchPlaceholder}
                  ref='skey'
                  onKeyUp={(e) => { this.onInputEvent(e) }}
                  onChange={this.onKeyChange}
                  onFocus={this.onFocus}
                  onBlur={this.onBlur}
                  disabled={ disabled }
                />
                <i
                  className={showClear ? 'material-icons pointer clearIcon' : 'material-icons pointer searchIcon'}
                  onClick={this.onToggleClearSearch}
                >
                  {showClear ? 'clear' : 'search'}
                </i>
              </div>
              {ingredientSearch ? null : this.renderSuggestions()}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SearchPanel;